export default __webpack_public_path__ + "static/media/watch_4.85cea743.jpg";